import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLBusinessLocationPage } from 'gwce-capability-fnol-common-react-ext';
import { ProductUtil } from 'wnice-portals-util-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';

function FNOLCPPBusinessLocationPage(props) {
    const {
        wizardData: claimVM
    } = props;

    const lineSelected = _.get(claimVM.value, 'policy.lobCode_Ext');

    switch(lineSelected) {
        case ProductUtil.FNOL_LOB_GL:
            return <FNOLBusinessLocationPage 
                    {...props}
                    LOB_NAME={ProductUtil.GL_LOB_NAME}
                    isCPPLine
            />;
        case ProductUtil.FNOL_LOB_CP:
            return <FNOLBusinessLocationPage 
                    {...props}
                    LOB_NAME={ProductUtil.CP_LOB_NAME}
                    isCPPLine
            />;
        case ProductUtil.FNOL_LOB_CR:
            return <FNOLBusinessLocationPage 
                    {...props}
                    LOB_NAME={ProductUtil.CR_LOB_NAME}
                    isCPPLine
            />;

        default:
            return <WizardPage/>; 
    }
}

FNOLCPPBusinessLocationPage.propTypes = wizardProps;
FNOLCPPBusinessLocationPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
};
export default withRouter(withAuthenticationContext(FNOLCPPBusinessLocationPage));
